// extracted by mini-css-extract-plugin
export default {"ticketCard":"TicketCard_ticketCard__+FVpc","mid":"TicketCard_mid__yiQeb","bot":"TicketCard_bot__Dm3fo"};